import React from 'react';
import ProfileMenu from './ProfileMenu';
import './EvaluatorInterface.css';
import { connect } from 'react-redux';


class Header extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

	        let logoSrc = this.props.faculdade?.logo || require('../assets/images/logo-ontest.png');
	        return (
            <div className="topbar evaluator-app-header" id="header_page" style={{position:this.props.sala_screen==true?'absolute':'fixed'}}>

                <div className="topbar-left evaluator-header-brand">
	                    {<a className="logo evaluator-header-logo">
	                        <span>
	                            <img src={logoSrc} alt={this.props.faculdade?.name || "OnTest"} height='70' />
	                        </span>
	                        <i>
	                            <img className="img-fluid" src={logoSrc} alt={this.props.faculdade?.name || "OnTest"} style={{height:70,objectFit:'contain'}} />
	                        </i>
	                    </a>}
                </div>
                <nav className="navbar-custom evaluator-header-nav">
                    <ul className="navbar-right evaluator-header-actions d-flex list-inline float-right mb-0">
                                                <ProfileMenu />

                    </ul>

                </nav>
            </div>

        );
    }


}

const mapsStateToProps = (state) => (
    {
        faculdade: state.AppReducer.faculdade,
    sala_screen: state.AppReducer.sala_screen,

    }
);

export default connect(mapsStateToProps, {})(Header);